import React, {FC} from 'react';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {RepositionPopover} from '../../../../libs/shared/ui/src/components/popovers/repositionPopover';
import {Anchor} from '../../../../libs/shared/ui/src/components/reposition/repositionHelpers';
import {PaletteColorsEnum} from '../../../../libs/shared/ui/src/styles/paletteModel';
import {ArbitraryCalendarEventModel} from '../../../models/api/arbitraryCalendarEventModel';
import {ArbitraryCalendarEventViewerContentContainer} from './arbitraryCalendarEventViewerContentContainer';
import {PopoverArbitraryCalendarEventViewerHeader} from './popoverArbitraryCalendarEventViewerHeader';
import {StyledContentDiv, StyledContentScrollerDiv, StyledLayoutDiv} from './popoverCalendarEventViewer';

/*
 * Props.
 */

interface PopoverArbitraryCalendarEventViewerProps {
  anchor: Anchor;
  arbitraryCalendarEvent: ArbitraryCalendarEventModel;
  color: PaletteColorsEnum;
  onRequestClose: Handler;
}

/*
 * Component.
 */

export const PopoverArbitraryCalendarEventViewer: FC<PopoverArbitraryCalendarEventViewerProps> = (props) => {
  const {onRequestClose, arbitraryCalendarEvent, color} = props;

  return (
    <RepositionPopover anchor={props.anchor} placement="right">
      <StyledLayoutDiv>
        <PopoverArbitraryCalendarEventViewerHeader onRequestClose={onRequestClose} />
        <StyledContentScrollerDiv>
          <StyledContentDiv>
            <ArbitraryCalendarEventViewerContentContainer
              color={color}
              arbitraryCalendarEvent={arbitraryCalendarEvent}
            />
          </StyledContentDiv>
        </StyledContentScrollerDiv>
      </StyledLayoutDiv>
    </RepositionPopover>
  );
};
